import { createAsyncThunk } from '@reduxjs/toolkit'
import { ShowException } from 'store/Application/appActions'
import { projectAPIBuilder } from './BoMAsyncActions'

export const recalculateProject = createAsyncThunk<any, any, { state: any }>(
  'project/recalculateProject',
  async (_args, thunkAPI) => {
    const { api, projectId } = projectAPIBuilder(thunkAPI.getState)

    try {
      return await api.Recalculate(projectId)
    } catch (ex) {
      ShowException('project', ex)
      throw ex
    }
  }
)
